var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4375 8.25H16.1562C16.6121 8.25 17.0493 8.43108 17.3716 8.75341C17.6939 9.07574 17.875 9.51291 17.875 9.96875V18.2188C17.875 18.6746 17.6939 19.1118 17.3716 19.4341C17.0493 19.7564 16.6121 19.9375 16.1562 19.9375H5.84375C5.38791 19.9375 4.95074 19.7564 4.62841 19.4341C4.30608 19.1118 4.125 18.6746 4.125 18.2188V9.96875C4.125 9.51291 4.30608 9.07574 4.62841 8.75341C4.95074 8.43108 5.38791 8.25 5.84375 8.25H7.5625M14.4375 5.5L11 2.0625M11 2.0625L7.5625 5.5M11 2.0625V13.793",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.c16c45a1969c8da038e35bc7fd934559.svg";
export { ForwardRef as ReactComponent };